import {useCallback, useEffect, useRef, useState} from 'react';

export const COPIED_MS = 1500;

export const copyText = async (text: string): Promise<void> => {
    if (!navigator.clipboard?.writeText) throw new Error('Clipboard is unavailable');
    await navigator.clipboard.writeText(text);
};

export const useCopyFeedback = () => {
    const [copied, setCopied] = useState(false);
    const [failed, setFailed] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timer.current), []);

    const copy = useCallback(async (text: string): Promise<boolean> => {
        clearTimeout(timer.current);
        try {
            await copyText(text);
            setFailed(false);
            setCopied(true);
            timer.current = setTimeout(() => setCopied(false), COPIED_MS);
            return true;
        } catch {
            setCopied(false);
            setFailed(true);
            timer.current = setTimeout(() => setFailed(false), COPIED_MS * 2);
            return false;
        }
    }, []);

    return {copied, failed, copy};
};
